module.exports = __webpack_public_path__ + "img/zztbg-5-en.4fa25729.png";